import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getBaseApiUrl, getConditionOverrides } from './util';
import { getRecoreImpressions } from './recoreImpressions';
function filterPayload(payload) {
  // remove $$typeof (react component) and functions/arrow-functions from payload
  var entries = Object.entries(payload);
  var filteredEntries = entries.filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return !value || !value.$$typeof && !value.apply && key !== 'method';
  });
  return Object.fromEntries(filteredEntries);
}

// eslint-disable-next-line max-statements
var recommendationsLaunch = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
    var url, options;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          url = getUrl(payload);
          options = getOptions(payload);
          return _context.abrupt("return", fetch(url, options));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function recommendationsLaunch(_x) {
    return _ref3.apply(this, arguments);
  };
}();
var prefetchRecommendations = function prefetchRecommendations() {
  var _window;
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var key = "".concat(payload === null || payload === void 0 ? void 0 : payload.component, "-").concat(payload === null || payload === void 0 ? void 0 : payload.id);
  window.rerec = ((_window = window) === null || _window === void 0 ? void 0 : _window.rerec) || {};
  window.rerec.rec = window.rerec.rec || {};
  var recoreImpressions = getRecoreImpressions();
  var recoreConditionOverrides = getConditionOverrides();
  var finalPayload = _objectSpread(_objectSpread({}, payload), {}, {
    recoreImpressions: recoreImpressions,
    recoreConditionOverrides: recoreConditionOverrides
  });
  window.rerec.rec[key] = window.rerec.rec[key] || recommendationsLaunch(finalPayload);
};
function isGet(payload) {
  var _payload$method;
  return ((_payload$method = payload.method) === null || _payload$method === void 0 ? void 0 : _payload$method.toLowerCase()) === 'get';
}
function getOptions(payload) {
  if (isGet(payload)) {
    return {
      method: 'GET',
      credentials: 'include',
      mode: 'cors'
      // custom headers omitted for compatibility with HTML preload
    };
  }
  return {
    method: 'POST',
    credentials: 'include',
    headers: {
      'content-type': 'application/json',
      'x-app-key': payload.appKey
    },
    body: JSON.stringify(filterPayload(payload))
  };
}
function getUrl(payload) {
  var _window2, _window2$location;
  var recoreImpressions = payload.recoreImpressions,
    recoreConditionOverrides = payload.recoreConditionOverrides;
  var extraParams = {
    recoreImpressions: recoreImpressions,
    recoreConditionOverrides: recoreConditionOverrides
  };
  var baseUrl = getBaseApiUrl(payload);
  var searchParams = new URLSearchParams((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.search);
  if (payload.recommendationUrl) {
    return payload.recommendationUrl;
  } else if (isGet(payload)) {
    var serializablePayload = filterPayload(payload);
    // Add all serializable payload params to the URL
    Object.entries(serializablePayload).forEach(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
        k = _ref5[0],
        v = _ref5[1];
      if (v != null && !Object.keys(extraParams).includes(k)) {
        searchParams.set(k, v);
      }
    });

    // Check if adding all extra params would exceed URL length limit
    var baseUrlWithParams = "".concat(baseUrl, "/v1/recommendations/launch?").concat(searchParams.toString());
    var combinedParams = Object.entries(extraParams).map(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
        k = _ref7[0],
        v = _ref7[1];
      return "&".concat(k, "=").concat(JSON.stringify(v));
    }).join('');

    // If adding all extra params would exceed URL length limit, add them individually if they fit
    if (baseUrlWithParams.length + combinedParams.length < 8000) {
      Object.entries(extraParams).forEach(function (_ref8) {
        var _ref9 = _slicedToArray(_ref8, 2),
          k = _ref9[0],
          v = _ref9[1];
        searchParams.set(k, JSON.stringify(v));
      });
    } else {
      Object.entries(extraParams).forEach(function (_ref0) {
        var _ref1 = _slicedToArray(_ref0, 2),
          k = _ref1[0],
          v = _ref1[1];
        if (baseUrlWithParams.length + "".concat(k, "=").concat(JSON.stringify(v)).length < 8000) {
          searchParams.set(k, JSON.stringify(v));
        }
      });
    }
  } else if (payload.basketId) {
    searchParams.set('basketId', payload.basketId);
  }
  return "".concat(baseUrl, "/v1/recommendations/launch?").concat(searchParams.toString());
}
export default prefetchRecommendations;
//# sourceMappingURL=prefetchRecommendations.js.map